import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Stack,
  Box,
} from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';

interface ErrorAlertModalProps {
  open: boolean;
  title: string;
  message: string;
  buttonLabel?: string;
  onClose: () => void;
  icon?: React.ReactNode;
}

const ErrorAlertModal: React.FC<ErrorAlertModalProps> = ({
  open,
  title,
  message,
  buttonLabel = 'Fechar',
  onClose,
  icon,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth='sm'
      fullWidth
      sx={{ '.MuiPaper-root': { padding: '1.5rem' } }}
    >
      <DialogContent>
        <Stack alignItems='center' spacing={2}>
          <Box
            sx={{
              backgroundColor: '#D32F2F',
              borderRadius: '50%',
              padding: '1rem',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {icon || (
              <ErrorIcon sx={{ color: '#FFFFFF', fontSize: '2.5rem' }} />
            )}
          </Box>
          <Typography
            variant='h6'
            align='center'
            fontWeight='bold'
            color='#D32F2F'
          >
            {title}
          </Typography>
          <Typography variant='body1' align='center' color='text.secondary'>
            {message}
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center' }}>
        <Button
          onClick={onClose}
          variant='contained'
          sx={{
            backgroundColor: '#D32F2F',
            color: '#FFFFFF',
            fontWeight: 'bold',
            textTransform: 'uppercase',
            padding: '8px 24px',
            '&:hover': {
              backgroundColor: '#B71C1C',
            },
          }}
        >
          {buttonLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ErrorAlertModal;
